<template>
  <FITFormCard>
    <div slot="header">
      <b-row align-v="center">
        <b-col cols="6">
          <span class="h5">{{ $t('osm.serviceRequest.header') }}</span>
        </b-col>
        <b-col cols="6" class="text-right" v-if="isReport">
          <b-button variant="success" size="md" @click="exportReport">{{ $t('dw.general.export') }}</b-button>
        </b-col>
      </b-row>
    </div>
    <div slot="formBody">
      <FITSearchableTable :autoSearchFilters="autoSearchFilters" :filters="filters" :columns="columns" @onRowSelected="onRowSelected" searchAction="getServiceRequestList" vuexModule="ServiceRequest" type="sr" v-model="currentFilters"></FITSearchableTable>
    </div>
  </FITFormCard>
</template>
<script type="text/javascript">
import {
  FITSearchableTable,
  FITFormCard
} from '@/components'
import { saveAs } from 'file-saver/FileSaver';

import { mapGetters } from 'vuex'
import Vue from 'vue'

export default {
  name: 'ServiceRequestList',
  components: {
    FITSearchableTable,
    FITFormCard
  },
  props: {
    isReport: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters('ServiceRequest', ['getServiceRequestTranslated']),
  },

  methods: {
    exportReport() {
      var filters = JSON.parse(JSON.stringify(this.currentFilters));
      filters.export = 1
      var params = this.$options.filters.removeEmptyObj(filters);
      console.debug(params);

      this.$store.dispatch('Dw/exportSrReport', params).then((json) => {
        var fileName = json.headers['content-disposition'];
        fileName = fileName.split(' ').join('');
        fileName = fileName.split('attachment;filename=').join('');
        var blob = new Blob([json.data]);
        saveAs(blob, fileName);
      })
    },
    onRowSelected(row) {
      if (this.isReport) {
        return;
      }
      let ID = row.ID
      this.$router.push({
        name: `serviceRequest-${row.serviceType.toLowerCase()}`,
        params: {
          ID: parseInt(ID),
          policy: {
            policyID: row.linkedEntityID,
            policyType: row.linkedEntity
          }
        }
      })
    },
    getDisplayName(item, key) {
      let english = (item[`${key}EnglishName`]) ? item[`${key}EnglishName`] : 'N/A';
      let chinese = (item[`${key}ChineseName`]) ? item[`${key}ChineseName`] : 'N/A';
      return `<span>${english}<br/>${chinese}</span>`
    },

    createServiceRequest() {
      this.$router.push('/osm/sr/create');
    },

    generatePolicyStatusDom(status, translatedStatus) {
      let icon = '';
      let text = 'danger';
      switch (status.toLowerCase()) {
        case 'pen':
          icon = 'fa-ellipsis-h'
          text = 'primary'
          break;
        case 'rej':
          icon = 'fa-times-circle'
          text = 'danger'
          break;
        case 'app':
          icon = 'fa-check-circle'
          text = 'success'
          break;
      }
      return `<span class="text-${text}"><i class="fa ${icon} mr-2"></i>${translatedStatus}</span>`;
    }
  },

  data() {
    return {
      currentFilters: {},
      columns: [{
        key: 'serviceType',
        label: this.$t('osm.serviceRequest.serviceType'),
        sortable: true,
        formatter: (row, key, item) => {
          return this.getServiceRequestTranslated(this.$i18n.locale, 'serviceType', row);
        }
      }, {
        key: 'customerID',
        label: this.$t('osm.serviceRequest.customer'),
        formatter: (row, key, item) => {
          return this.getDisplayName(item, 'customer');
        }
      }, {
        key: 'agentID',
        label: this.$t('osm.serviceRequest.creator'),
        formatter: (row, key, item) => {
          return this.getDisplayName(item, 'agent');
        }
      }, {
        key: 'linkedEntity',
        label: this.$t('osm.serviceRequest.policyType'),
        sortable: true,
        thClass: ['bulletin-time', 'text-center'],
        tdClass: ['text-center'],
        formatter: (row, key, item) => {
          // return this.generatePolicyStatusDom(row, this.getServiceRequestTranslated(this.$i18n.locale, 'linkedEntity', row));
          return this.getServiceRequestTranslated(this.$i18n.locale, 'linkedEntity', row);
        }
      }, {
        key: 'policyNumber',
        label: this.$t('osm.serviceRequest.policy.policyNumber'),
        sortable: true,
        thClass: ['bulletin-time', 'text-center'],
        tdClass: ['text-center'],
        formatter: (row, key, item) => {
          return this.$options.filters.isEmpty(row);
        }
      }, {
        key: 'serviceRequestStatus',
        label: this.$t('osm.serviceRequest.status'),
        sortable: true,
        thClass: ['bulletin-time', 'text-center'],
        tdClass: ['text-center'],
        formatter: (row, key, item) => {
          return this.generatePolicyStatusDom(row, this.getServiceRequestTranslated(this.$i18n.locale, 'serviceRequestStatus', row));
          // return this.getServiceRequestTranslated(this.$i18n.locale, 'serviceRequestStatus', row);
        }
      }, {
        key: 'receiveTime',
        label: this.$t('osm.serviceRequest.receiveTime'),
        sortable: true,
        thClass: ['bulletin-time', 'text-center'],
        tdClass: ['text-center'],
        formatter: (row, key, item) => {
          return Vue.options.filters.date(row);
        }
      }],
      filters: [{
          label: this.$t('osm.serviceRequest.policyType'),
          key: 'linkedEntity',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('osm.serviceRequest.status'),
          key: 'serviceRequestStatus',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('osm.serviceRequest.serviceType'),
          key: 'serviceType',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('general.fromDate'),
          key: 'fromDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('general.toDate'),
          key: 'toDate',
          type: 'datetime',
          default: ''
        }
      ],

      autoSearchFilters: [{
        label: this.$t('osm.serviceRequest.creator'),
        key: 'agentID',
        searchParams: {
          placeholder: 'Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: "agent" }],
          showItems: ['englishFullname', 'chineseFullname', 'agentCode']
        }
      }, {
        label: this.$t('osm.serviceRequest.customer'),
        key: 'customerID',
        searchParams: {
          placeholder: 'Type to search',
          dest: 'option',
          paras: [{ key: 'type', value: "customer" }],
          showItems: ['englishFullname', 'chineseFullname']
        }
      }],
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestList.vue